export default {
  backgroundColor: '#ffffff',
  backgroundColor_active: '#ebeff5',
  backgroundColor_disabled: '#ebeff5',
  backgroundColor_focus: '#ffffff',
  backgroundColor_hover: '#f5f7fa',
  backgroundColor_brand_selected: '#f0f5fc',
  backgroundColor_brand_selectedActive: '#accbfc',
  backgroundColor_brand_selectedHover: '#cfe0fc',
  backgroundColor_brandPrimary: '#3272d9',
  backgroundColor_brandPrimary_active: '#1d5bbf',
  backgroundColor_brandPrimary_focus: '#3272d9',
  backgroundColor_brandPrimary_hover: '#5691f0',
  backgroundColor_danger_active: '#fad4d4',
  backgroundColor_danger_focus: '#faf0f0',
  backgroundColor_danger_hover: '#faf0f0',
  backgroundColor_dangerPrimary: '#de1b1b',
  backgroundColor_dangerPrimary_active: '#b80d0d',
  backgroundColor_dangerPrimary_focus: '#de1b1b',
  backgroundColor_dangerPrimary_hover: '#f55353',
  backgroundColor_success_active: '#abedc5',
  backgroundColor_success_focus: '#e1faeb',
  backgroundColor_success_hover: '#e1faeb',
  backgroundColor_successPrimary: '#2a854e',
  backgroundColor_successPrimary_active: '#20693d',
  backgroundColor_successPrimary_focus: '#2a854e',
  backgroundColor_successPrimary_hover: '#3ba164',
  backgroundColor_warning_active: '#fad8af',
  backgroundColor_warning_focus: '#fcf2e6',
  backgroundColor_warning_hover: '#fcf2e6',
  backgroundColor_warningPrimary: '#ad5f00',
  backgroundColor_warningPrimary_active: '#8a4d03',
  backgroundColor_warningPrimary_focus: '#ad5f00',
  backgroundColor_warningPrimary_hover: '#cf7911',
  borderColor: '#c8d1e0',
  borderColor_brand: '#3272d9',
  borderColor_brand_active: '#1d5bbf',
  borderColor_brand_focus: '#1d5bbf',
  borderColor_brand_hover: '#5691f0',
  borderColor_danger: '#de1b1b',
  borderColor_danger_active: '#b80d0d',
  borderColor_danger_focus: '#b80d0d',
  borderColor_danger_hover: '#f55353',
  borderColor_success: '#2a854e',
  borderColor_success_active: '#20693d',
  borderColor_success_focus: '#20693d',
  borderColor_success_hover: '#3ba164',
  borderColor_warning: '#ad5f00',
  borderColor_warning_active: '#8a4d03',
  borderColor_warning_focus: '#8a4d03',
  borderColor_warning_hover: '#cf7911',
  borderRadius_1: '3px',
  boxShadow_1: '0 1px 2px 0 rgba(0,0,0,0.2), 0 2px 4px 0 rgba(0,0,0,0.2)',
  boxShadow_2: '0 2px 4px 0 rgba(0,0,0,0.2), 0 4px 8px 0 rgba(0,0,0,0.2)',
  boxShadow_3: '0 4px 8px 0 rgba(0,0,0,0.2), 0 8px 16px 0 rgba(0,0,0,0.2)',
  boxShadow_4: '0 8px 16px 0 rgba(0,0,0,0.2), 0 20px 16px -8px rgba(0,0,0,0.2)',
  boxShadow_5: '0 16px 24px 0 rgba(0,0,0,0.2), 0 32px 24px -16px rgba(0,0,0,0.2)',
  breakpoint_narrow: '512px',
  breakpoint_medium: '768px',
  breakpoint_wide: '1024px',
  color: '#333840',
  color_inverted: '#ffffff',
  color_disabled: '#afbacc',
  color_mouse: '#58606e',
  color_readOnly: '#58606e',
  color_required: '#de1b1b',
  color_brand: '#3272d9',
  color_brandPrimary: '#ffffff',
  color_brand_active: '#1d5bbf',
  color_brand_focus: '#3272d9',
  color_brand_hover: '#5691f0',
  color_danger: '#de1b1b',
  color_dangerPrimary: '#ffffff',
  color_danger_active: '#b80d0d',
  color_danger_focus: '#de1b1b',
  color_danger_hover: '#f55353',
  color_success: '#2a854e',
  color_successPrimary: '#ffffff',
  color_success_active: '#20693d',
  color_success_focus: '#2a854e',
  color_success_hover: '#3ba164',
  color_warning: '#ad5f00',
  color_warningPrimary: '#ffffff',
  color_warning_active: '#8a4d03',
  color_warning_focus: '#ad5f00',
  color_warning_hover: '#cf7911',
  fontFamily: '"Open Sans"',
  fontFamily_system: '-apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  fontFamily_monospace: '"SF Mono", "Droid Sans Mono", "Source Code Pro", Monaco, Consolas, "Courier New", Courier, monospace',
  fontSize_base: '1rem',
  fontSize_mouse: '0.6875rem',
  fontSize_prose: '1rem',
  fontSize_ui: '0.875rem',
  fontWeight_regular: 400,
  fontWeight_semiBold: 600,
  fontWeight_bold: 700,
  fontWeight_extraBold: 800,
  lineHeight: 1.25,
  lineHeight_heading: 1.25,
  lineHeight_heading_small: 1.5,
  lineHeight_prose: 1.5,
  size_small: '24px',
  size_medium: '32px',
  size_large: '40px',
  size_jumbo: '52px',
  space_inline_xxs: '2px',
  space_inline_xs: '4px',
  space_inline_sm: '8px',
  space_inline_md: '16px',
  space_inline_lg: '24px',
  space_inline_xl: '32px',
  space_inline_xxl: '64px',
  space_inset_sm: '8px',
  space_inset_md: '16px',
  space_inset_lg: '24px',
  space_stack_xxs: '2px',
  space_stack_xs: '4px',
  space_stack_sm: '8px',
  space_stack_md: '16px',
  space_stack_lg: '24px',
  space_stack_xl: '32px',
  space_stack_xxl: '64px',
  zIndex_100: 100,
  zIndex_200: 200,
  zIndex_400: 400,
  zIndex_800: 800,
  zIndex_1600: 1600,
  h1_color: '#333840',
  h1_fontSize: '2.125rem',
  h1_fontWeight: 800,
  h2_color: '#58606e',
  h2_fontSize: '1.75rem',
  h2_fontWeight: 700,
  h3_color: '#58606e',
  h3_fontSize: '1.375rem',
  h3_fontWeight: 700,
  h4_color: '#58606e',
  h4_fontSize: '1.125rem',
  h4_fontWeight: 700,
  h5_color: '#333840',
  h5_fontSize: '0.875rem',
  h5_fontWeight: 700,
  h6_color: '#58606e',
  h6_fontSize: '0.875rem',
  h6_fontWeight: 400,
  icon_color: '#58606e',
  icon_color_brand: '#3272d9',
  icon_color_danger: '#de1b1b',
  icon_color_success: '#2a854e',
  icon_color_warning: '#ad5f00',
  input_backgroundColor: '#ffffff',
  input_backgroundColor_disabled: '#ebeff5',
  input_color_placeholder: '#8e99ab',
  panel_backgroundColor: '#ffffff',
  panel_backgroundColor_inverted: '#434a54',
  panel_borderColor: '#ebeff5',
  panel_borderColor_inverted: '#434a54',
  well_backgroundColor: '#ebeff5',
  well_backgroundColor_danger: '#fad4d4',
  well_backgroundColor_success: '#abedc5',
  well_backgroundColor_warning: '#fad8af',
  well_borderColor_danger: '#fa8e8e',
  well_borderColor_success: '#57c282',
  well_borderColor_warning: '#e89c3f'
};